import PropTypes from 'prop-types';

import { Chip } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import Photos from '../../components/Slider/icons/Photos';

import './ImageMosaic.scss';

const extractMainImages = images => images.slice(0, 3);

const ImageMosaic = ({ imageTrack = [], onClick = () => {} }) => {
  const [leftImage, rightImageTop, rightImageBottom] =
    extractMainImages(imageTrack);

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <div className="imageMosaic" onClick={onClick} role="img">
      <div className="imageMosaic__left_image">
        <img src={leftImage.src} alt="left_image" rel="preload" />
      </div>
      <div className="imageMosaic__right_image_top">
        <img src={rightImageTop.src} alt="right_image_top" rel="preload" />
      </div>
      <div className="imageMosaic__right_image_bottom">
        <img
          src={rightImageBottom.src}
          alt="right_image_bottom"
          rel="preload"
        />
        <Chip.Choice
          renderLeadingIcon={() => (
            <Photos size="small" theme="interactionDark" />
          )}
          className="imageMosaic__right_image_bottom__chip"
          onClick={onClick}
          label={trans('mosaic.chip.text')}
        />
      </div>
    </div>
  );
};

ImageMosaic.propTypes = {
  imageTrack: PropTypes.arrayOf(
    PropTypes.shape({
      caption: PropTypes.string,
      src: PropTypes.string.isRequired
    })
  ),
  onClick: PropTypes.func
};

export default ImageMosaic;
